import { useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import { useGetShareContent } from './content';
import { useOnShareSuccess } from './success';
import { useGetShareTrackingData } from './tracking';
import { useGetShareUrl } from './url';

export function useShareOptions(): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetShareUrl();
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();
	const {
		data: {
			petition: { bestShareVisual },
			isSunriseEnabled,
		},
	} = usePsfSharePageData();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getUrl,
			getContent,
			getTrackingData,
			onSuccess,
			config: {
				isSunriseEnabled,
				instagramStories: {
					enabled: !!bestShareVisual,
				},
				tiktok: {
					enabled: !!bestShareVisual,
				},
			},
		}),
		[getUrl, getContent, getTrackingData, onSuccess, isSunriseEnabled, bestShareVisual],
	);
}
